<template>
  <div>
    <main-layout>
      <div class="content-wrap" v-loading="loading">
        <div class="box-card-one el-tabs__content">
          <div class="topTab">
            <div class="topNav">商户信息</div>
          </div>
          <div class="divTop">
            <div class="u-shoptitle">商户名</div>
            <span class="u-shopmsg">{{ enterpriseName }}</span>
          </div>
          <div class="divCenter" v-if="registerType == -1">
            <div class="u-shoptitle">自然人姓名</div>
            <span class="u-shopmsg">{{ legalPerson }}</span>
          </div>
          <div class="divCenter e-mb32">
            <div class="u-shoptaxnum">{{ registerType == -1 ? '自然人身份证号' : '企业税号' }}</div>
            <span class="u-shopmsg">
              {{ registerType == -1 ? idCardPlain : taxNo }}
            </span>
          </div>
        </div>
        <div class="box-card-two el-tabs__content">
          <div class="topTab">
            <div class="topNav">清算卡</div>
          </div>
          <div class="divTop-two">
            <span class="u-cardtitle">账户类型</span>
            <span class="u-cardcontent">{{ accountType }}</span>
          </div>
          <div class="divCenter-two">
            <span class="u-cardtitle">入账周期</span>
            <span class="u-cardcontent" v-if="settleMode == '01'">T0</span>
            <span class="u-cardcontent" v-else-if="settleMode == '02'">T1</span>
          </div>
          <div class="divBottom-two">
            <span class="u-cardtitle">费率</span>
            <span>
              <p class="u-cardcontent f-di" v-if="weixinRate != ''">微信：{{ weixinRate }}%</p>
              <p class="u-cardcontent f-di e-ml32" v-if="zfbRate != ''">支付宝：{{ zfbRate }}%</p>
            </span>
          </div>
          <div class="divCenter">
            <span class="u-accountname">账户名</span>
            <span class="u-cardcontent">{{ bankAccountName }}</span>
          </div>
          <div class="divCenter">
            <span class="u-cardtitle">银行卡号</span>
            <span class="u-cardcontent">{{ bankAccountNoPlain }}</span>
          </div>
          <div class="divCenter">
            <span class="u-banktitle">开户行</span>
            <span class="u-bankcontent">{{ subbranchName || '-' }}</span>
          </div>
        </div>
        <div class="box-card-three el-tabs__content">
          <div class="topTab">
            <div class="topNav">我的服务人员</div>
          </div>
          <div class="divTop-two">
            <span class="u-cardtitle">姓名</span>
            <span class="u-cardcontent">{{ serverName || '-' }}</span>
          </div>
          <div class="divCenter-two">
            <span class="u-cardtitle">手机号</span>
            <span class="u-cardcontent">{{ serverPhone || '-' }}</span>
          </div>
        </div>
        <div class="box-card-three el-tabs__content">
          <div class="topTab">
            <div class="topNav">动态收款码配置</div>
          </div>
          <div class="divTop-two">
            <el-form :model="form" label-position="left" label-width="132px" size="small">
              <el-form-item label="备注是否必填" prop="isApiRemark">
                <el-radio-group v-model="form.isApiRemark">
                  <el-radio :label="false">非必填</el-radio>
                  <el-radio :label="true">必填</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="save-wrap">
          <el-button type="primary" v-preventReClick @click="handleSubmit" size="medium"
            >保存</el-button
          >
        </div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/views/layout/mainlayout';
import { countAll } from '@/utils/count';
import axiosRequestNew from '@api/axiosRequestNew';

export default {
  name: 'Account',
  data() {
    return {
      data: {},
      codes: '',
      codelist: [],
      jskpCode: '',
      enterpriseName: '',
      taxNo: '',
      accountType: '',
      settleMode: '',
      weixinRate: '',
      zfbRate: '',
      bankAccountName: '',
      bankAccountNoPlain: '',
      subbranchName: '',
      marginleft: true,
      issidebar: false,
      isindexqr: true,
      isindex: false,
      contentHeight: window.innerHeight - 167,
      loading: true,
      qrurl: 'https://jskp.jss.com.cn/k.action?kpdm=',
      registerType: '', // 用户类型
      legalPerson: '', // 自然人姓名
      idCardPlain: '', // 自然人身份证号
      serverName: '',
      serverPhone: '',
      // qrurl:"https://jskptest.jss.com.cn/k.action?kpdm="
      form: { isApiRemark: false },
    };
  },
  components: {
    MainLayout,
  },
  created() {
    this.registerType = sessionStorage.getItem('registerType');
    // _.debounce 是一个通过 lodash 限制操作频率的函数。
    const payState = sessionStorage.getItem('payState');
    if (payState && payState != '0') {
      this.getmsg();
    }
  },
  methods: {
    getmsg() {
      this.api
        .get('info/queryCustomerInfo.do', {
          params: '',
        })
        .then((res) => {
          this.loading = false;
          const { data } = res;
          if (res.code == '200') {
            this.codelist = data.customerExts;
            this.jskpCode = data.jskpCode;
            this.enterpriseName = data.enterpriseName;
            this.taxNo = data.taxNo;
            this.legalPerson = data.legalPerson;
            this.idCardPlain = data.idCardPlain;
            if (data.accountType == '1') {
              this.accountType = '对私';
            } else if (data.accountType == '0') {
              this.accountType = '对公';
            }
            this.settleMode = data.settleMode;
            this.weixinRate = data.weixinRate ? countAll.count('*', data.weixinRate, 100) : '';
            this.zfbRate =
              data.zfbRate === 0 || data.zfbRate ? countAll.count('*', data.zfbRate, 100) : '';
            this.bankAccountName = data.bankAccountName;
            this.bankAccountNoPlain = data.bankAccountNoPlain;
            this.subbranchName = data.subbranchName;
            this.serverName = data.serverName;
            this.serverPhone = data.serverPhone;
            this.form.isApiRemark = data.isApiRemark || false;
          } else {
            this.$message.error('系统错误');
          }
        });
    },
    handleSubmit() {
      const isApiRemark = this.form.isApiRemark;
      this.loading = true;

      axiosRequestNew
        .post(
          'update/setApiRemark',
          {
            isApiRemark,
          },
          {
            headers: {
              isRequestPayload: true,
            },
          },
        )
        .then((res) => {
          const { data } = res;
          if (res.code == '200') {
            this.$message.success('提交成功');
          } else {
            this.$message.error('系统错误');
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.f-dn {
  display: none;
}

.u-content .divCenter.e-mb32 {
  margin-bottom: 32px;
}

i.iconfont.icon-QRcode {
  color: #c0c4cc;
  font-size: 14px;
}

.f-di {
  display: inline;
}

.e-ml32 {
  margin-left: 32px;
}

.u-content {
  .box-card-one {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    text-align: left;
  }

  .topTab {
    height: 36px;
    border: 1px solid #e4e7ed;
    border-top: none;
    border-right: none;
    border-left: none;
    background-color: #f5f7fa;
  }

  .u-shoptitle {
    width: 132px;
    display: inline-block;
    font-size: 14px;
    color: #909399;
  }

  .u-shopmsg {
    font-size: 14px;
  }

  .u-shoptaxnum {
    width: 132px;
    display: inline-block;
    font-size: 14px;
    color: #909399;
  }

  .topNav {
    float: left;
    color: #303133;
    line-height: 36px;
    margin-left: 16px;
    font-weight: 600;
    font-size: 14px;
  }

  .divTop {
    margin: 32px 0 20px 32px;
  }

  .divCenter {
    margin: 0 0 22px 32px;
  }

  .divBottom {
    margin: 0 32px 24px 0;

    .u-paycode {
      font-size: 14px;
      color: #909399;
      width: 134px;
      height: 62px;
      float: left;
      margin-left: 32px;
    }
  }

  .u-codes {
    display: inline-block;
    margin-bottom: 16px;
    width: 130px;
  }

  .u-codesone.u-codes {
    width: 125px;
  }

  .u-codetitle {
    display: inline;
    font-size: 14px;
    color: #606266;
    margin-right: 3px;
  }

  .u-codes .el-button {
    padding: 0;
    border: none;
    margin-right: 30px;
    background-color: #fff;
  }

  .box-card-two {
    height: 320px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-top: 32px;
  }

  .divTop-two {
    display: block;
    margin: 30px 0 20px 32px;
  }

  .divCenter-two {
    display: block;
    margin: 0 0 20px 32px;
  }

  .divBottom-two {
    display: block;
    margin: 0 0 20px 32px;
  }

  .image {
    text-align: center;
    margin: 25px 0 8px;
  }

  .u-cardtitle {
    width: 132px;
    display: inline-block;
    font-size: 14px;
    color: #909399;
  }

  .u-cardcontent {
    font-size: 14px;
    color: #606266;
  }

  .u-banktitle {
    width: 132px;
    display: inline-block;
    font-size: 14px;
    color: #909399;
  }

  .u-bankcontent {
    font-size: 14px;
    color: #606266;
  }

  .u-accountname {
    font-size: 14px;
    color: #909399;
    margin-right: 88px;
  }

  .box-card-three {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-top: 32px;
  }
}

.u-qrlayer {
  padding: 0;
}

.u-qrlayer p {
  margin: 8px 0;
  text-align: center;
}

.u-qrcodebox {
  margin: 25px 25px 0 25px;
  width: 100px;
  height: 100px;
}

.save-wrap {
  margin-top: 30px;
  padding-left: 8px;
}
</style>
